import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '../api';
import Layout from '../components/Layout';


const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes rowIn{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:translateX(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes newBadge{0%{transform:scale(1)}50%{transform:scale(1.08)}100%{transform:scale(1)}}
  *{box-sizing:border-box}
  .mr-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}
  .mr-input{padding:9px 14px;background:#fff;border:1.5px solid #e2e8f5;border-radius:10px;
    color:#1a1d2e;font-size:13px;font-family:'DM Sans',sans-serif;outline:none;
    transition:border-color 0.2s,box-shadow 0.2s}
  .mr-input:focus{border-color:#f59e0b;box-shadow:0 0 0 3px rgba(245,158,11,0.12)}
  .mr-input[type=date]{cursor:pointer}
  .mr-btn-danger{padding:10px 20px;background:linear-gradient(135deg,#f87171,#ef4444);
    border:none;border-radius:10px;color:#fff;font-size:13px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:7px}
  .mr-btn-danger:hover{transform:translateY(-2px);box-shadow:0 6px 18px rgba(239,68,68,0.35)}
  .mr-btn-danger:disabled{opacity:0.5;cursor:not-allowed;transform:none}
  .mr-btn-secondary{padding:9px 18px;background:#fff;border:1.5px solid #e2e8f5;
    border-radius:10px;color:#4a5568;font-size:13px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .mr-btn-secondary:hover{background:#f8faff;border-color:#f59e0b;color:#b45309}
  .mr-row:hover td{background:#fffbeb !important;transition:background 0.15s}
  .action-btn{width:32px;height:32px;border:none;border-radius:8px;cursor:pointer;font-size:14px;
    display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.18);box-shadow:0 4px 12px rgba(0,0,0,0.14)}
  .skeleton{background:linear-gradient(90deg,#fffbeb 25%,#fef3c7 50%,#fffbeb 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}
  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(245,158,11,0.15);color:#fbbf24;border-left:3px solid #fbbf24;padding-left:13px}
  .cb-box{width:17px;height:17px;border-radius:4px;border:2px solid #d1d5db;
    display:flex;align-items:center;justify-content:center;flex-shrink:0;
    transition:all 0.15s;background:#fff;cursor:pointer}
  .cb-box.on{background:#f59e0b;border-color:#f59e0b}
  .cb-box.on::after{content:'✓';color:#fff;font-size:10px;font-weight:800}
  .cb-box.partial{background:#fef3c7;border-color:#f59e0b}
  .cb-box.partial::after{content:'–';color:#b45309;font-size:11px;font-weight:800}
  .badge{padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;display:inline-block}
  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#fde68a;border-radius:3px}
  .search-box{padding:9px 14px 9px 38px;border:1.5px solid #e2e8f5;border-radius:20px;
    background:#fff;font-size:13px;outline:none;width:220px;
    transition:border-color 0.2s,box-shadow 0.2s,width 0.3s;color:#1a1d2e;font-family:'DM Sans',sans-serif}
  .search-box:focus{border-color:#f59e0b;box-shadow:0 0 0 3px rgba(245,158,11,0.12);width:280px}
  .info-row{display:flex;align-items:flex-start;gap:14px;padding:11px 0;border-bottom:1px solid #fffbeb}
  .info-icon{width:34px;height:34px;background:#fffbeb;border-radius:10px;
    display:flex;align-items:center;justify-content:center;font-size:15px;flex-shrink:0}
  .new-pulse{animation:newBadge 1.5s ease-in-out infinite}
`;

// const NAV = [
//   {icon:'⬡',  label:'Dashboard',          path:'/dashboard'},
//   {icon:'👥',  label:'User Management',    path:'/user-management'},
//   {icon:'⏱️',  label:'Rent Durations',     path:'/rent-durations'},
//   {icon:'🛡️',  label:'Insurance Day Slab', path:'/insurance-day-slab'},
//   {icon:'💰',  label:'Car Price',          path:'/car-price'},
//   {icon:'🚕',  label:'Transfer Price',     path:'/transfer-price'},
//   {icon:'📅',  label:'Weekend Rate',       path:'/weekend-rate'},
//   {icon:'🚖',  label:'Cab Details',        path:'/cab-details'},
//   {icon:'📝',  label:'Page Content',       path:'/page-content'},
//   {icon:'🚗',  label:'Manage Request',     path:'/manage-request'},
//   {icon:'📋',  label:'Bookings',           path:'/bookings'},
// ];

const PER_PAGE = 10;

export default function ManageRequest() {
  const navigate = useNavigate();
  const location = useLocation();

  const [authUser,   setAuthUser]   = useState(null);
  const [sideOpen,   setSideOpen]   = useState(true);
  const [requests,   setRequests]   = useState([]);
  const [total,      setTotal]      = useState(0);
  const [loading,    setLoading]    = useState(true);
  const [page,       setPage]       = useState(1);
  const [search,     setSearch]     = useState('');
  const [fromDate,   setFromDate]   = useState('');
  const [toDate,     setToDate]     = useState('');
  const [selected,   setSelected]   = useState([]);
  const [viewModal,  setViewModal]  = useState(null);
  const [delModal,   setDelModal]   = useState(null); // single
  const [bulkModal,  setBulkModal]  = useState(false);
  const [delSaving,  setDelSaving]  = useState(false);
  const [toast,      setToast]      = useState(null);

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return; }
    setAuthUser(JSON.parse(localStorage.getItem('user') || '{}'));
  }, []);

  useEffect(() => { fetchRequests(); }, [page, search, fromDate, toDate]);

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page, limit: PER_PAGE,
        ...(search   && {search}),
        ...(fromDate && {fromDate}),
        ...(toDate   && {toDate}),
      });
      const r = await API.get(`/manage-request?${params}`);
      setRequests(r.data.data);
      setTotal(r.data.total);
    } catch(e) { showToast('Failed to load requests', 'error'); }
    setLoading(false);
  };

  const showToast = (msg, type='success') => {
    setToast({msg, type});
    setTimeout(() => setToast(null), 3500);
  };

  const handleSearch = useCallback((val) => {
    setSearch(val); setPage(1); setSelected([]);
  }, []);

  const handleDateFilter = () => { setPage(1); setSelected([]); fetchRequests(); };
  const clearFilters = () => { setSearch(''); setFromDate(''); setToDate(''); setPage(1); setSelected([]); };

  // Selection
  const toggleSelect = (id) =>
    setSelected(s => s.includes(id) ? s.filter(i=>i!==id) : [...s, id]);
  const toggleAll = () =>
    setSelected(s => s.length === requests.length ? [] : requests.map(r=>r.req_id));
  const selState = selected.length === 0 ? 'none'
    : selected.length === requests.length ? 'all' : 'partial';

  // Delete single
  const handleDeleteSingle = async () => {
    setDelSaving(true);
    try {
      await API.delete(`/manage-request/${delModal.req_id}`);
      showToast('Request deleted ✓');
      setDelModal(null);
      setSelected(s => s.filter(i=>i!==delModal.req_id));
      await fetchRequests();
    } catch(e) { showToast(e.response?.data?.message||'Delete failed','error'); }
    setDelSaving(false);
  };

  // Delete bulk
  const handleDeleteBulk = async () => {
    if (!selected.length) return;
    setDelSaving(true);
    try {
      await API.delete('/manage-request', { data: { ids: selected } });
      showToast(`${selected.length} request(s) deleted ✓`);
      setBulkModal(false);
      setSelected([]);
      await fetchRequests();
    } catch(e) { showToast(e.response?.data?.message||'Bulk delete failed','error'); }
    setDelSaving(false);
  };

  const totalPages = Math.ceil(total / PER_PAGE);

  const fmtDate = (d) => {
    if (!d) return '—';
    try { return new Date(d).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}); }
    catch { return d; }
  };

  const fullName = (r) =>
    [r.req_title, r.req_firstname, r.req_lastname].filter(Boolean).join(' ');

  const isToday = (d) => {
    if (!d) return false;
    const today = new Date().toISOString().split('T')[0];
    return d.toString().startsWith(today);
  };

  const logout = () => { localStorage.clear(); navigate('/login'); };

  return (
    <Layout activePage="TransferBooking">
    <>
      <style>{STYLES}</style>
      <div style={S.root} className="mr-root">


        {/* ── Main ── */}
        <main>

          {/* Header */}
          <div style={S.pageHeader}>
            <div>
              <h1 style={S.pageTitle}>Manage Requests</h1>
              <p style={S.pageSub}>Car rental enquiries from customers</p>
            </div>
            <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
              {[
                {label:'Total',   value:total,  color:'#b45309',bg:'#fffbeb',icon:'📬'},
                {label:'Selected',value:selected.length,color:'#ef4444',bg:'#fff5f5',icon:'☑️'},
              ].map(s=>(
                <div key={s.label} style={{...S.miniStat,background:s.bg}}>
                  <span style={{fontSize:20}}>{s.icon}</span>
                  <div>
                    <div style={{fontSize:22,fontWeight:800,color:s.color,lineHeight:1}}>{s.value}</div>
                    <div style={{fontSize:10,color:'#718096',fontWeight:600,textTransform:'uppercase'}}>{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Filters + Actions bar ── */}
          <div style={S.filterCard}>
            <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap',flex:1}}>
              {/* Search */}
              <div style={{position:'relative'}}>
                <span style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',
                  color:'#a0aec0',fontSize:13,pointerEvents:'none'}}>🔍</span>
                <input className="search-box" placeholder="Search name, email, mobile…"
                  value={search} onChange={e=>handleSearch(e.target.value)}/>
              </div>

              {/* Date range */}
              <div style={{display:'flex',alignItems:'center',gap:6}}>
                <span style={{fontSize:12,color:'#718096',fontWeight:600,whiteSpace:'nowrap'}}>From:</span>
                <input className="mr-input" type="date" value={fromDate}
                  onChange={e=>{setFromDate(e.target.value);setPage(1);}}/>
                <span style={{fontSize:12,color:'#718096',fontWeight:600}}>To:</span>
                <input className="mr-input" type="date" value={toDate}
                  min={fromDate}
                  onChange={e=>{setToDate(e.target.value);setPage(1);}}/>
              </div>

              {(search||fromDate||toDate) && (
                <button className="mr-btn-secondary" onClick={clearFilters}>✕ Clear</button>
              )}
            </div>

            {/* Bulk delete */}
            {selected.length > 0 && (
              <button className="mr-btn-danger" onClick={()=>setBulkModal(true)}>
                🗑 Delete Selected ({selected.length})
              </button>
            )}
          </div>

          {/* ── Table ── */}
          <div style={S.tableCard}>
            <div style={S.tableCardHead}>
              <h3 style={S.tableCardTitle}>📋 Request List</h3>
              <span style={{fontSize:12,background:'#fef3c7',color:'#b45309',
                borderRadius:20,padding:'4px 14px',fontWeight:700}}>
                {total} total
              </span>
            </div>

            <div style={{overflowX:'auto'}}>
              <table style={S.table}>
                <thead>
                  <tr style={{background:'linear-gradient(135deg,#fffbeb,#fef3c7)'}}>
                    <th style={{...S.th,width:42}}>
                      <div className={`cb-box${selState==='all'?' on':selState==='partial'?' partial':''}`}
                        onClick={toggleAll}/>
                    </th>
                    {['Name','Request Date','Pickup Date','Drop-off Date',
                      'Email','Mobile','Actions'].map(h=>(
                      <th key={h} style={S.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? Array.from({length:6}).map((_,i)=>(
                        <tr key={i}>{Array.from({length:8}).map((_,j)=>(
                          <td key={j} style={S.td}>
                            <div className="skeleton" style={{height:14,width:'75%'}}/>
                          </td>
                        ))}</tr>
                      ))
                    : requests.length===0
                    ? (
                        <tr>
                          <td colSpan={8} style={{textAlign:'center',padding:'52px 0',color:'#a0aec0'}}>
                            <div style={{fontSize:44,marginBottom:10}}>📬</div>
                            <div style={{fontSize:15,fontWeight:600}}>No requests found</div>
                            <div style={{fontSize:13,marginTop:6}}>
                              {search||fromDate||toDate
                                ? 'Try adjusting your filters'
                                : 'No customer requests yet'}
                            </div>
                          </td>
                        </tr>
                      )
                    : requests.map((r,i)=>{
                        const isSel    = selected.includes(r.req_id);
                        const todayReq = isToday(r.request_date);
                        return (
                          <tr key={r.req_id} className="mr-row"
                            style={{borderBottom:'1px solid #fffbeb',
                              background:isSel?'#fffbeb':i%2===0?'#fff':'#fdfdf9'}}>
                            <td style={S.td}>
                              <div className={`cb-box${isSel?' on':''}`}
                                onClick={()=>toggleSelect(r.req_id)}/>
                            </td>
                            <td style={S.td}>
                              <div style={{display:'flex',alignItems:'center',gap:10}}>
                                <div style={{width:36,height:36,borderRadius:10,flexShrink:0,
                                  background:'linear-gradient(135deg,#fbbf24,#f59e0b)',
                                  display:'flex',alignItems:'center',justifyContent:'center',
                                  color:'#fff',fontWeight:800,fontSize:14}}>
                                  {(r.req_firstname||'?')[0].toUpperCase()}
                                </div>
                                <div>
                                  <div style={{fontWeight:700,fontSize:13,color:'#1a1d2e'}}>
                                    {fullName(r)}
                                  </div>
                                  {r.req_city && (
                                    <div style={{fontSize:11,color:'#a0aec0'}}>
                                      📍 {r.req_city}
                                      {r.req_country ? `, ${r.req_country}` : ''}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td style={S.td}>
                              <div style={{display:'flex',flexDirection:'column',gap:3}}>
                                <span style={{fontWeight:600,fontSize:13,color:'#374151'}}>
                                  {fmtDate(r.request_date)}
                                </span>
                                {todayReq && (
                                  <span className="badge new-pulse"
                                    style={{background:'#fef3c7',color:'#b45309',fontSize:10}}>
                                    🆕 Today
                                  </span>
                                )}
                              </div>
                            </td>
                            <td style={{...S.td,color:'#4b5563',fontSize:13}}>
                              {fmtDate(r.req_pick_date)}
                            </td>
                            <td style={{...S.td,color:'#4b5563',fontSize:13}}>
                              {fmtDate(r.req_drop_off_date)}
                            </td>
                            <td style={{...S.td,color:'#4b5563',fontSize:13}}>
                              {r.req_email||'—'}
                            </td>
                            <td style={S.td}>
                              <span style={{fontFamily:'monospace',fontWeight:700,fontSize:13,
                                color:'#1a1d2e'}}>
                                {r.req_mobile||'—'}
                              </span>
                            </td>
                            <td style={S.td}>
                              <div style={{display:'flex',gap:6}}>
                                <button className="action-btn"
                                  style={{background:'#fef3c7',color:'#b45309'}}
                                  title="View Details"
                                  onClick={()=>setViewModal(r)}>👁</button>
                                <button className="action-btn"
                                  style={{background:'#fff5f5',color:'#c53030'}}
                                  title="Delete"
                                  onClick={()=>setDelModal(r)}>🗑</button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                  }
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={S.pagination}>
                <span style={{fontSize:13,color:'#718096'}}>
                  Showing {(page-1)*PER_PAGE+1}–{Math.min(page*PER_PAGE,total)} of {total}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  {Array.from({length:totalPages},(_,i)=>i+1)
                    .filter(p => p===1||p===totalPages||Math.abs(p-page)<=2)
                    .reduce((acc,p,i,arr)=>{
                      if(i>0&&arr[i-1]!==p-1) acc.push('...');
                      acc.push(p); return acc;
                    },[])
                    .map((p,i)=>
                      p==='...'
                        ? <span key={i} style={{padding:'0 4px',color:'#a0aec0'}}>…</span>
                        : <button key={p}
                            style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}}
                            onClick={()=>setPage(p)}>{p}</button>
                    )
                  }
                  <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              </div>
            )}
          </div>
        </main>

        {/* ── View Modal ── */}
        {viewModal && (
          <div style={S.overlay} onClick={()=>setViewModal(null)}>
            <div style={{...S.modal,maxWidth:560}} onClick={e=>e.stopPropagation()}>
              <div style={S.modalHead}>
                <div>
                  <h2 style={S.modalTitle}>🚗 Request Details</h2>
                  <p style={S.modalSub}>#{viewModal.req_id} · {fmtDate(viewModal.request_date)}</p>
                </div>
                <button style={S.xBtn} onClick={()=>setViewModal(null)}>✕</button>
              </div>
              <div className="modal-scroll" style={{padding:'16px 28px 20px'}}>

                {/* Customer hero */}
                <div style={{display:'flex',alignItems:'center',gap:16,padding:'16px',
                  background:'linear-gradient(135deg,#fffbeb,#fef3c7)',
                  borderRadius:16,marginBottom:20,border:'1.5px solid #fde68a'}}>
                  <div style={{width:52,height:52,borderRadius:16,flexShrink:0,
                    background:'linear-gradient(135deg,#fbbf24,#f59e0b)',
                    display:'flex',alignItems:'center',justifyContent:'center',
                    color:'#fff',fontWeight:800,fontSize:22}}>
                    {(viewModal.req_firstname||'?')[0].toUpperCase()}
                  </div>
                  <div>
                    <div style={{fontSize:18,fontWeight:800,color:'#1a1d2e'}}>{fullName(viewModal)}</div>
                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                      {viewModal.req_driver_age && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                          Age {viewModal.req_driver_age}
                        </span>
                      )}
                      {viewModal.req_city && (
                        <span className="badge" style={{background:'#ecfeff',color:'#0e7490'}}>
                          📍 {viewModal.req_city}
                          {viewModal.req_country?`, ${viewModal.req_country}`:''}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Contact info */}
                {[
                  {label:'Email',       value:viewModal.req_email,   icon:'✉️'},
                  {label:'Mobile',      value:viewModal.req_mobile,  icon:'📞'},
                  {label:'Address',     value:viewModal.req_address, icon:'🏠'},
                  {label:'Postcode',    value:viewModal.req_postcode,icon:'🔢'},
                ].filter(r=>r.value).map(row=>(
                  <div key={row.label} className="info-row">
                    <div className="info-icon">{row.icon}</div>
                    <div>
                      <div style={{fontSize:10,color:'#f59e0b',fontWeight:700,
                        textTransform:'uppercase',letterSpacing:'0.4px'}}>{row.label}</div>
                      <div style={{fontSize:14,color:'#1a1d2e',fontWeight:500,marginTop:2}}>
                        {row.value}
                      </div>
                    </div>
                  </div>
                ))}

                {/* Trip info */}
                <div style={{marginTop:20,background:'#fff',borderRadius:14,
                  border:'1.5px solid #fde68a',overflow:'hidden'}}>
                  <div style={{background:'linear-gradient(135deg,#fbbf24,#f59e0b)',
                    padding:'10px 16px',fontWeight:700,fontSize:12,color:'#fff',
                    textTransform:'uppercase',letterSpacing:'0.5px'}}>
                    🚗 Trip Details
                  </div>
                  <div style={{padding:'4px 0'}}>
                    {[
                      {label:'Request Date',    value:fmtDate(viewModal.request_date),    icon:'📅'},
                      {label:'Pickup Date',     value:fmtDate(viewModal.req_pick_date),   icon:'🟢'},
                      {label:'Drop-off Date',   value:fmtDate(viewModal.req_drop_off_date),icon:'🔴'},
                      {label:'Pickup Time',     value:viewModal.req_pick_time?`${viewModal.req_pick_time}:00`:'—', icon:'⏰'},
                      {label:'Drop-off Time',   value:viewModal.req_drop_off_time?`${viewModal.req_drop_off_time}:00`:'—', icon:'⏰'},
                      {label:'Pickup Location', value:viewModal.req_pick_location||'—',   icon:'📍'},
                      {label:'Drop-off Location',value:viewModal.req_drop_off_location||'—',icon:'📍'},
                    ].map(row=>(
                      <div key={row.label} className="info-row" style={{padding:'10px 16px'}}>
                        <div className="info-icon">{row.icon}</div>
                        <div>
                          <div style={{fontSize:10,color:'#b45309',fontWeight:700,
                            textTransform:'uppercase',letterSpacing:'0.4px'}}>{row.label}</div>
                          <div style={{fontSize:13,color:'#374151',fontWeight:600,marginTop:2}}>
                            {row.value}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Comments */}
                {viewModal.req_details && (
                  <div style={{marginTop:16}}>
                    <div style={{fontSize:11,color:'#b45309',fontWeight:700,
                      textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:8}}>
                      💬 Comments / Details
                    </div>
                    <div style={{background:'#fffbeb',borderRadius:12,padding:'14px 16px',
                      border:'1.5px solid #fde68a',fontSize:14,color:'#374151',
                      lineHeight:1.7,whiteSpace:'pre-wrap',wordBreak:'break-word'}}>
                      {viewModal.req_details}
                    </div>
                  </div>
                )}
              </div>
              <div style={S.modalFoot}>
                <button className="mr-btn-secondary" onClick={()=>setViewModal(null)}>Close</button>
                <button className="mr-btn-danger"
                  onClick={()=>{setViewModal(null);setTimeout(()=>setDelModal(viewModal),100);}}>
                  🗑 Delete This Request
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Delete Single Modal ── */}
        {delModal && (
          <div style={S.overlay} onClick={()=>setDelModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>
                  Delete Request?
                </h2>
                <div style={{marginBottom:16,display:'flex',gap:8,justifyContent:'center',flexWrap:'wrap'}}>
                  <span className="badge" style={{background:'#fef3c7',color:'#b45309',fontSize:13}}>
                    {fullName(delModal)}
                  </span>
                  <span className="badge" style={{background:'#f1f5f9',color:'#64748b'}}>
                    {fmtDate(delModal.request_date)}
                  </span>
                </div>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  Are you sure you want to delete this request?<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="mr-btn-secondary" onClick={()=>setDelModal(null)}>Cancel</button>
                  <button disabled={delSaving} className="mr-btn-danger" onClick={handleDeleteSingle}>
                    {delSaving?<span style={S.spinner}/>:'🗑️ Delete'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Bulk Delete Modal ── */}
        {bulkModal && (
          <div style={S.overlay} onClick={()=>setBulkModal(false)}>
            <div style={{...S.modal,maxWidth:440}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>
                  Delete {selected.length} Request{selected.length!==1?'s':''}?
                </h2>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  You are about to permanently delete{' '}
                  <strong style={{color:'#1a1d2e'}}>{selected.length} selected request{selected.length!==1?'s':''}</strong>.<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="mr-btn-secondary" onClick={()=>setBulkModal(false)}>Cancel</button>
                  <button disabled={delSaving} className="mr-btn-danger" onClick={handleDeleteBulk}>
                    {delSaving
                      ? <span style={S.spinner}/>
                      : `🗑️ Delete ${selected.length} Request${selected.length!==1?'s':''}`}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div style={{...S.toast,
            background:toast.type==='error'?'#fff5f5':'#fffbeb',
            borderColor:toast.type==='error'?'#fc8181':'#fbbf24',
            color:toast.type==='error'?'#c53030':'#b45309'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      </div>
    </>
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root:{display:'flex',minHeight:'100vh',background:'#fffdf5'},
  sidebar:{background:'#1a1d2e',color:'#fff',display:'flex',flexDirection:'column',
    position:'fixed',height:'100vh',transition:'width 0.25s',overflow:'hidden',zIndex:100},
  sideTop:{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'20px 16px 16px'},
  logoWrap:{display:'flex',alignItems:'center',gap:10},
  logoIcon:{width:36,height:36,background:'linear-gradient(135deg,#fbbf24,#f59e0b)',borderRadius:10,
    display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0},
  logoText:{fontSize:18,fontWeight:800,letterSpacing:'-0.5px',whiteSpace:'nowrap',fontFamily:"'Syne',sans-serif"},
  collapseBtn:{background:'rgba(255,255,255,0.08)',border:'none',color:'#aaa',borderRadius:6,
    padding:'4px 8px',cursor:'pointer',fontSize:11,flexShrink:0},
  sideBottom:{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.07)'},
  userChip:{display:'flex',alignItems:'center',gap:10,marginBottom:12},
  avatar:{width:36,height:36,background:'linear-gradient(135deg,#fbbf24,#f59e0b)',borderRadius:'50%',
    display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,fontSize:15,flexShrink:0},
  uname:{fontSize:13,fontWeight:700,color:'#fff'},
  urole:{fontSize:11,color:'#777'},
  logoutBtn:{width:'100%',background:'rgba(251,191,36,0.12)',border:'1px solid rgba(251,191,36,0.25)',
    color:'#fbbf24',borderRadius:8,padding:'8px 12px',cursor:'pointer',fontSize:13,
    display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'inherit'},

  main:{flex:1,padding:'28px',minWidth:0},
  pageHeader:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    marginBottom:20,flexWrap:'wrap',gap:16},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,
    fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  miniStat:{display:'flex',alignItems:'center',gap:12,borderRadius:14,padding:'14px 18px',
    boxShadow:'0 2px 10px rgba(0,0,0,0.05)'},

  filterCard:{display:'flex',justifyContent:'space-between',alignItems:'center',
    flexWrap:'wrap',gap:12,marginBottom:16,background:'#fff',borderRadius:14,
    padding:'14px 18px',boxShadow:'0 2px 12px rgba(0,0,0,0.05)',border:'1.5px solid #fef3c7'},

  tableCard:{background:'#fff',borderRadius:20,overflow:'hidden',
    boxShadow:'0 4px 24px rgba(245,158,11,0.08)',marginBottom:20,border:'1.5px solid #fde68a'},
  tableCardHead:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'20px 24px',borderBottom:'1px solid #fffbeb'},
  tableCardTitle:{fontSize:16,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  table:{width:'100%',borderCollapse:'collapse'},
  th:{padding:'13px 14px',fontSize:11,fontWeight:700,color:'#b45309',textAlign:'left',
    textTransform:'uppercase',letterSpacing:'0.5px',borderBottom:'2px solid #fef3c7'},
  td:{padding:'12px 14px',fontSize:13,color:'#4a5568',verticalAlign:'middle'},

  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'16px 24px',borderTop:'1px solid #fffbeb'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #fde68a',borderRadius:8,background:'#fff',
    color:'#b45309',fontSize:13,fontWeight:600,cursor:'pointer',
    fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#f59e0b',borderColor:'#f59e0b',color:'#fff'},

  overlay:{position:'fixed',inset:0,background:'rgba(10,5,0,0.6)',zIndex:200,
    display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:620,maxHeight:'90vh',
    display:'flex',flexDirection:'column',
    boxShadow:'0 32px 80px rgba(245,158,11,0.2)',animation:'modalIn 0.3s ease both'},
  modalHead:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    padding:'24px 28px 0',flexShrink:0},
  modalTitle:{fontSize:20,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  modalSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  modalFoot:{display:'flex',gap:12,justifyContent:'flex-end',
    padding:'16px 28px',borderTop:'1px solid #fffbeb',flexShrink:0},
  xBtn:{background:'rgba(245,158,11,0.12)',border:'none',color:'#b45309',borderRadius:'50%',
    width:32,height:32,cursor:'pointer',fontWeight:800,fontSize:14,
    display:'flex',alignItems:'center',justifyContent:'center'},
  spinner:{display:'inline-block',width:14,height:14,border:'2px solid rgba(255,255,255,0.3)',
    borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',bottom:28,right:28,zIndex:999,padding:'14px 22px',
    borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,
    fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.12)',
    animation:'fadeSlideIn 0.3s ease'},
};